import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { TreoNavigationItem } from '@treo/components/navigation';
import { TreoMockApi } from '@treo/lib/mock-api/mock-api.interfaces';
import { TreoMockApiService } from '@treo/lib/mock-api/mock-api.service';
import { compactNavigation, defaultNavigation, futuristicNavigation, horizontalNavigation } from 'app/data/mock/common/navigation/data';
import { Usuarios } from 'app/models/Usuario/usuarios.model';

@Injectable({
    providedIn: 'root'
})
export class NavigationMockApi implements TreoMockApi {
    // Private Readonly
    private readonly _compactNavigation: TreoNavigationItem[];
    private _defaultNavigation: TreoNavigationItem[];
    private readonly _futuristicNavigation: TreoNavigationItem[];
    private _horizontalNavigation: TreoNavigationItem[];
    usuario: Usuarios = JSON.parse(localStorage.getItem('usuario'));

    /**
     * Constructor
     *
     * @param _treoMockApiService
     */
    constructor(
        private _treoMockApiService: TreoMockApiService
    ) {
        // Set the data
        this._compactNavigation = compactNavigation;

        this._futuristicNavigation = futuristicNavigation;
        this._horizontalNavigation = defaultNavigation;

        // Register the API endpoints
        this.register();

        if (this.usuario != null) {
            if (this.usuario.tipo == "Administrador") {
                this.navAdmin();
            }
            else if (this.usuario.tipo == "Vendedor") {
                this.navVendedor();
            }
            else if (this.usuario.tipo == "Gerente") {
                this.navGerente();
            }
            else if (this.usuario.tipo == "Programador") {
                this.navProgramador();
            }
            else if(this.usuario.tipo == "Apostador"){
                this.navApostador();
            }
            else {
                this.navCliente();
            }
        }



    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    navAdmin() {
        this._horizontalNavigation = [

            {
                id: 'jogos',
                title: 'Jogos',
                type: 'basic',
                link: '/jogos',
                icon: 'mat_outline:sports_soccer'
            },
            {
                id: 'usuarios',
                title: 'Usuários',
                type: 'collapsable',
                icon: 'mat_outline:account_box',
                children: [
                    {
                        id: 'gerentes',
                        title: 'Gerentes',
                        type: 'basic',
                        link: '/gerentes'
                    },
                    {
                        id: 'vendedores',
                        title: 'Vendedores',
                        type: 'basic',
                        link: '/vendedores'
                    }
                ]

            },
            {
                id: 'bilhetes',
                title: 'Bilhetes',
                type: 'basic',
                link: '/bilhetes',
                icon: 'mat_outline:receipt'
            },
            {
                id: 'caixa',
                title: 'Caixa',
                type: 'basic',
                link: '/caixa',
                icon: 'mat_outline:account_balance_wallet'
            },
            {
                id: 'financeiro',
                title: 'Financeiro',
                type: 'basic',
                link: '/financeiro',
                icon: 'mat_outline:attach_money',
            },
            {
                id: 'adiantamentos',
                title: 'Adiantamentos',
                type: 'basic',
                link: '/adiantamentos',
                icon: 'heroicons_outline:cash',
            },
            {
                id: 'gerenciamento',
                title: 'Gerenciamento',
                type: 'collapsable',
                icon: 'mat_outline:verified_user',
                children: [
                    {
                        id: 'mapa',
                        title: 'Mapa de Apostas',
                        type: 'basic',
                        link: '/mapa',
                        icon: 'mat_outline:map'
                    },
                    /* {
                        id: 'riscos',
                        title: 'Gerenciar Riscos',
                        type: 'basic',
                        link: '/riscos',
                        icon: 'mat_outline:assignment_late'
                    }, */
                    {
                        id: 'cotacoes',
                        title: 'Gerenciar Cotações',
                        type: 'basic',
                        link: '/cotacoes',
                        icon: 'mat_outline:swap_vert'
                    },
                    {
                        id: 'bloqueios',
                        title: 'Gerenciar Bloqueios',
                        type: 'basic',
                        link: '/bloqueios',
                        icon: 'mat_outline:block'
                    },
                ]

            },

            {
                id: 'configuracoes',
                title: 'Configurações',
                type: 'basic',
                link: '/configuracoes',
                icon: 'mat_outline:settings'
            },

            {
                id: 'regras',
                title: 'Regras',
                type: 'basic',
                link: '/regras',
                icon: 'mat_outline:help_outline'
            }

        ];

        this._defaultNavigation = this._horizontalNavigation;
    }

    navGerente() {
        this._horizontalNavigation = [
            {
                id: 'jogos',
                title: 'Jogos',
                type: 'basic',
                link: '/jogos',
                icon: 'mat_outline:sports_soccer'
            },
            {
                id: 'usuarios',
                title: 'Usuários',
                type: 'collapsable',
                icon: 'mat_outline:account_box',
                children: [
                    {
                        id: 'vendedores',
                        title: 'Vendedores',
                        type: 'basic',
                        link: '/vendedores'
                    }
                ]

            },
            {
                id: 'bilhetes',
                title: 'Bilhetes',
                type: 'basic',
                link: '/bilhetes',
                icon: 'mat_outline:receipt'
            },
            {
                id: 'financeiro',
                title: 'Financeiro',
                type: 'basic',
                link: '/financeiro',
                icon: 'mat_outline:attach_money'
            },
            {
                id: 'regras',
                title: 'Regras',
                type: 'basic',
                link: '/regras',
                icon: 'mat_outline:assignment_late'
            }

        ];
        this._defaultNavigation = this._horizontalNavigation;
    }

    navVendedor() {
        this._horizontalNavigation = [
            {
                id: 'jogos',
                title: 'Jogos',
                type: 'basic',
                link: '/jogos',
                icon: 'mat_outline:sports_soccer'
            },
            {
                id: 'bilhetes',
                title: 'Bilhetes',
                type: 'basic',
                link: '/bilhetes',
                icon: 'mat_outline:receipt'
            },
            {
                id: 'caixa',
                title: 'Caixa',
                type: 'basic',
                link: '/caixa',
                icon: 'mat_outline:account_balance_wallet'
            },
            {
                id: 'regras',
                title: 'Regras',
                type: 'basic',
                link: '/regras',
                icon: 'mat_outline:assignment_late'
            }
        ];
        this._defaultNavigation = this._horizontalNavigation;
    }

    navCliente() {
        this._horizontalNavigation = [
            {
                id: 'jogos',
                title: 'Jogos',
                type: 'basic',
                link: '/jogos',
                icon: 'mat_outline:sports_soccer'
            },
            {
                id: 'regras',
                title: 'Regras',
                type: 'basic',
                link: '/regras',
                icon: 'mat_outline:assignment_late'
            }
        ];
    }

    navApostador() {
        this._horizontalNavigation = [
            {
                id: 'jogos',
                title: 'Jogos',
                type: 'basic',
                link: '/jogos',
                icon: 'mat_outline:sports_soccer'
            },
            {
                id: 'bilhetes',
                title: 'Bilhetes',
                type: 'basic',
                link: '/bilhetes',
                icon: 'mat_outline:receipt'
            },
            {
                id: 'regras',
                title: 'Regras',
                type: 'basic',
                link: '/regras',
                icon: 'mat_outline:assignment_late'
            }
        ];
        this._defaultNavigation = this._horizontalNavigation;
    }

    navProgramador() {
        this._horizontalNavigation = [
            {
                id: 'resultados',
                title: 'Resultados',
                type: 'basic',
                link: '/resultados',
                icon: 'mat_outline:refresh'
            }
        ];
        this._defaultNavigation = this._horizontalNavigation;
    }

    /**
     * Register
     */
    register(): void {
        // -----------------------------------------------------------------------------------------------------
        // @ Navigation - GET
        // -----------------------------------------------------------------------------------------------------
        this._treoMockApiService
            .onGet('api/common/navigation')
            .reply(() => {

                return [
                    200,
                    {
                        compact: _.cloneDeep(this._compactNavigation),
                        default: _.cloneDeep(this._defaultNavigation),
                        futuristic: _.cloneDeep(this._futuristicNavigation),
                        horizontal: _.cloneDeep(this._horizontalNavigation)
                    }
                ];
            });
    }
}
